<script>
export default {
  name: "formInput",
  components: {},
  props: {
    //值
    value: {
      type: [String, Number],
      default: () => ""
    }
  },
  data() {
    return {
      realValue: this.value
    };
  },
  watch: {
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    }
  },
  render() {
    const option = {
      props: {
        value: this.realValue
      },
      attrs: {
        type: "hidden"
      },
      ref: "input"
    };
    return <input {...option} />;
  }
};
</script>

<style lang="less" scoped></style>
